import React, { useMemo } from 'react';
import FieldWrapper from '../../ui/field-wrapper';
import { RicosViewerLazy } from '../../loadable';
import { FIELD_TYPES } from '../../constants';
import { getHeaderAndParagraphCustomStyles } from '../../loadable/ricos-viewer/theme-utils';
import { useConfig } from '../../contexts/config-context';
const getCustomThemeClass = compId => "rich-text-custom-theme" + (compId != null ? compId : '');
const RichText = _ref => {
  let {
    content,
    id
  } = _ref;
  const {
    compId
  } = useConfig();
  const customTheme = useMemo(() => ({
    parentClass: getCustomThemeClass(compId),
    customStyles: getHeaderAndParagraphCustomStyles()
  }), [compId]);
  return /*#__PURE__*/React.createElement(FieldWrapper, {
    fieldType: FIELD_TYPES.RICH_TEXT,
    dataHook: id
  }, /*#__PURE__*/React.createElement("div", {
    className: getCustomThemeClass(compId)
  }, /*#__PURE__*/React.createElement(RicosViewerLazy, {
    content: content,
    customTheme: customTheme
  })));
};
export default RichText;
//# sourceMappingURL=rich-text.js.map